import MetricsIcon from '../../../components/globals/Icons/LensIcons/MetricsIcon.vue'
import PerformanceMetricsIcon from '../../../components/globals/Icons/LensIcons/filters/PerformanceMetricsIcon.vue'
import EngagementMetricsIcon from '../../../components/globals/Icons/LensIcons/filters/EngagementMetricsIcon.vue'
import MediaMetricsIcon from '../../../components/globals/Icons/LensIcons/filters/MediaMetricsIcon.vue'
import ConversionMetricsIcon from '../../../components/globals/Icons/LensIcons/filters/ConversionMetricsIcon.vue'
import MetaMetricsIcon from '../../../components/globals/Icons/LensIcons/MetaMetricsIcon.vue'
import TagIcon from '../../../components/globals/Icons/TagIcon.vue'
import store from '../../../store'
import getFilterTypeOperations from './filterTypeOperations'

const NO_FILTER_METRICS = ['percent_of_purchase_value', 'percent_of_spend']

const getMetricInputPlaceholder = (type) => {
  switch (type) {
    case 'number': return 'Value'
    case 'currency': return 'Amount'
    case 'percent': return 'Rate'
    default: return 'Value'
  }
}

const convertToFilterSchema = (metrics) => {
  return metrics.map(metric => ({
    optionType: 'metric',
    name: metric.name,
    key: metric.key,
    validOperations: getFilterTypeOperations(metric.type),
    input: { type: metric.type, placeholder: getMetricInputPlaceholder(metric.type) }
  }))
}

const getMetricOptions = (parentGroup, excludedSubsections = []) => {
  const metrics = store.getters['MetricsModule/getMetricGroups']
  const groupMetrics = metrics?.[parentGroup]
    ?.filter(metric => !excludedSubsections.includes(metric?.child_group) && !excludedSubsections.includes(metric?.table_group)) ??
    []

  return convertToFilterSchema(groupMetrics).filter(metric => !NO_FILTER_METRICS.includes(metric.key))
}

const getSubSectionMetricOptions = (parentGroup, subSection) => {
  const metrics = store.getters['MetricsModule/getMetricGroups']
  let subSectionMetrics = metrics?.[parentGroup]?.filter(metric => metric?.child_group === subSection) ?? []
  if (!subSectionMetrics.length) {
    subSectionMetrics = metrics?.[parentGroup]?.filter(metric => metric?.table_group === subSection) ?? []
  }

  return convertToFilterSchema(subSectionMetrics).filter(metric => !NO_FILTER_METRICS.includes(metric.key))
}

const getTagOptions = () => {
  const lensTags = store.getters['LensModule/getLensTags']

  return [
    {
      optionType: 'metadata',
      name: 'Tag',
      key: 'custom_tag',
      input: { type: 'search', placeholder: 'Tag name', searchOptions: lensTags },
      validOperations: getFilterTypeOperations('dropdown')
    }
  ]
}

export default function dynamicFilterOptions () {
  const filterCategories = [
    {
      categoryName: 'Foreplay Scores',
      categoryId: 'foreplay_metrics',
      icon: MetricsIcon,
      options: getMetricOptions('foreplay_metrics'),
      foreplayMetrics: true
    },
    {
      categoryName: 'Performance Metrics',
      categoryId: 'performance',
      icon: PerformanceMetricsIcon,
      options: getMetricOptions('performance')
    },
    {
      categoryName: 'Engagement Metrics',
      categoryId: 'engagement',
      icon: EngagementMetricsIcon,
      options: getMetricOptions('engagement')
    },
    {
      categoryName: 'Media Metrics',
      categoryId: 'media',
      icon: MediaMetricsIcon,
      options: getMetricOptions('media')
    },
    {
      categoryName: 'Conversion Metrics',
      categoryId: 'conversions',
      icon: ConversionMetricsIcon,
      options: getMetricOptions('conversions', ['custom_conversions'])
    },
    {
      categoryName: 'Tags',
      categoryId: 'tags',
      icon: TagIcon,
      options: getTagOptions(),
      isSingleOption: true
    }
  ]
  console.log('%c Filter Categories', 'color: blue; font-weight: bold;', filterCategories)
  const customConversions = getSubSectionMetricOptions('conversions', 'custom_conversions')
  console.log('%c Custom Conversions', 'color: blue; font-weight: bold;', customConversions)
  if (customConversions?.length) {
    filterCategories.push({
      categoryName: 'Custom Conversions',
      categoryId: 'custom_conversions',
      icon: MetaMetricsIcon,
      options: customConversions
    })
  }

  return filterCategories
}
